module.exports = __webpack_public_path__ + "img/22_9.7756c886.png";